
export default {
  name: 'KycInfo',
}
